/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, IconButton, Switch } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import IosSwitchMain from "../../components/iosSwitchMain";

const RolesList = () => {

    const navigate = useNavigate();

    const label = { inputProps: { 'aria-label': 'Switch demo' } };

    const rows = [
        {
            id: 1,
            date: "01 March 2025"
        },
        {
            id: 2,
            date: "01 March 2025"
        },
        {
            id: 3,
            date: "01 March 2025"
        },
        {
            id: 4,
            date: "01 March 2025"
        },
        {
            id: 5,
            date: "01 March 2025"
        },
    ];
    const columns: GridColDef<(typeof rows)[number]>[] = [
        {
            flex: 2,
            minWidth: 180,
            field: "name",
            headerName: "Role Name",
            editable: false,
            sortable: false,
            renderCell: () => {
                return (
                    <div className="user_block click_action" onClick={() => navigate("/manage-subadmin/roles/detail")}>
                        <p><b>Role 1</b></p>
                    </div>
                )
            }
        },
        {
            flex: 1,
            minWidth: 150,
            field: "date",
            headerName: "Created Date",
            editable: false,
            sortable: false,
        },
        {
            flex: 1,
            minWidth: 100,
            field: "status",
            headerName: "Status",
            editable: false,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: () => {
                return (
                    <IosSwitchMain />
                )
            }
        },
        {
            minWidth: 130,
            field: "action",
            headerName: "Action",
            editable: false,
            sortable: false,
            renderCell: () => {
                return (
                    <div className="table_actions v2">
                       
                        <Box>
                            <IconButton onClick={() => navigate("/manage-subadmin/roles/add")}>
                                <img src="/static/images/edit2_icon.svg" alt="" />
                            </IconButton>
                        </Box>
                        <Box>
                            <IconButton>
                                <img src="/static/images/trash2_icon.svg" alt="" />
                            </IconButton>
                        </Box>
                    </div>
                )
            }
        }
    ];
    let hidden = ["fullName"];

    return (
        <>
            <div className="sorting_table">
                <TableComponent
                    columns={columns?.filter((item) => !hidden.includes(item.field))}
                    rows={rows}
                />
            </div>
        </>
    );
};

export default RolesList;
